import React from "react";
import moment from "moment";
import { getAppPath } from "constants/path";
import Typography from "@material-ui/core/Typography";
import SearchBox from "storybookComponents/SearchBox";
import Button from "storybookComponents/Button";
import StyledTable from 'components/StyledTable';
import { compare } from "content/utils/commonParsing.js";
import Tooltip from "storybookComponents/Tooltip2";
import Picker from "storybookComponents/Picker";
import EmptyScreen from "components/EmptyScreen";

import Loader from "storybookComponents/Loader";

const MyApprovals = ({
  showFilter,
  classes,
  showNotification,
  org,
  history,
  data,
  isLoading,
  ...rest
}) => {
  const [rows, setRows] = React.useState(null);

  // Filter table by property

  const handleFilterTime = (e) => {
    if (e) {
      let filteredData = data.slice().filter((item) => {
        if (item.publishAt) {
          return moment(item.publishAt).format("MMM DD, YYYY") == moment(e).format("MMM DD, YYYY");
        }
      });
      setRows(getRows(filteredData));
    } else {
      setRows(getRows(data));
    }
  };

  const handleFilterProperty = (f, fieldName) => {
    setRows(
      getRows(
        data.slice().filter((item) => {
          return item[fieldName].toLowerCase().includes(f.toLowerCase());
        })
      )
    );
  };

  // Sort properties by stats
  const handleSort = (field, order) => {
    let sortedData = data.slice().sort((a, b) => {
      return compare(a[field], b[field], !order);
    });
    setRows(getRows(sortedData));
  };

  const handleAnalyzeClick = (item) => {
    return window.open(getAppPath(item.propertyId) + `/event/${item.id}`, "_blank");
  };

  const getRows = (d) => {
    return d.map((item) => {
      const { publishAt, title, propertyName } = item;
      const approverEmails = item.approverEmails.split(",");
      return {
        publishAt: (
          <Typography className={`${classes.tableText} ${classes.bold}`} noWrap>
            {moment(publishAt).format("D MMM YYYY, h:mmA")}
          </Typography>
        ),
        propertyName: (
          <Typography className={classes.tableText} noWrap>
            {propertyName}
          </Typography>
        ),
        title: (
          <Typography className={classes.tableText} noWrap>
            {title}
          </Typography>
        ),
        approverEmails: (
          <Tooltip text={item.approverEmails}>
            <Typography className={classes.tableText} noWrap>
              {approverEmails.length > 1 ? (
                <>
                  {approverEmails[0]},{" "}
                  <span className={classes.extraNumber}>+{approverEmails.length - 1}</span>
                </>
              ) : (
                approverEmails[0]
              )}
            </Typography>
          </Tooltip>
        ),
        action: (
          <Button variant="secondary" onClick={handleAnalyzeClick.bind(this, item)}>
            <span className={classes.tableText}>
              {!rest.isApprover ? "View Event" : "Review to Approve"}
            </span>
          </Button>
        ),
      };
    });
  };

  const getData = async () => {
    setRows(getRows(data));
  };

  const columns = [
    {
      field: "publishAt",
      fieldName: "Scheduled Date",
      sortable: true,
      className: classes.tableHeader,
      cellClassName: classes.tableCell,
      filterable: true,
      filterField: (
        <div id="hyly-datePicker-blast-approval">
          <Picker
            allowPast
            type="date"
            icon={true}
            handleChange={handleFilterTime}
            showButton={true}
            alignCalendarPopup="left"
          />
        </div>
      ),
    },
    {
      field: "propertyName",
      fieldName: "Property",
      sortable: true,
      className: classes.tableHeader,
      cellClassName: classes.tableCell,
      filterable: true,
      filterField: (
        <div style={{ display: "flex", alignItems: "center", marginTop: 8 }}>
          <SearchBox
            onSearch={(e) => handleFilterProperty(e, "propertyName")}
            searchType="auto"
            placeholder=""
          />
        </div>
      ),
    },
    {
      field: "title",
      fieldName: "Event",
      sortable: true,
      className: classes.tableHeader,
      cellClassName: classes.tableCell,
      filterable: true,
      filterField: (
        <div style={{ display: "flex", alignItems: "center", marginTop: 8 }}>
          <SearchBox
            onSearch={(e) => handleFilterProperty(e, "title")}
            searchType="auto"
            placeholder=""
          />
        </div>
      ),
    },
    {
      field: "approverEmails",
      fieldName: "Approver(s)",
      sortable: true,
      className: classes.tableHeader,
      cellClassName: classes.tableCell,
      filterable: true,
      filterField: (
        <div style={{ display: "flex", alignItems: "center", marginTop: 8 }}>
          <SearchBox
            onSearch={(e) => handleFilterProperty(e, "approverEmails")}
            searchType="auto"
            placeholder=""
          />
        </div>
      ),
    },
    {
      field: "action",
      fieldName: "",
      align: "right",
      className: classes.tableHeader,
      cellClassName: classes.tableCell,
    },
  ];

  React.useEffect(() => {
    getData();
  }, [isLoading, data]);

  React.useEffect(() => {
    handleFilterProperty("", "propertyName");
  }, [showFilter]);

  return (
    <div className={classes.contentBox}>
      {isLoading ? (
        <Loader />
      ) : data.length == 0 ? (
        <EmptyScreen text="All done! No new approval requests." />
      ) : (
        <StyledTable
          columns={rest.isAllTabsAccess ? [...columns.slice(0, 3), ...columns.slice(4)] : columns}
          rows={rows}
          sortHandler={handleSort}
          showFilter={showFilter}
          defaultSortBy="publishAt"
        />
      )}
    </div>
  );
};

export default MyApprovals;
